import styled from "styled-components";
import { GenericSvg } from "../assets/svgs/GenericSVG";
import { handleLogout } from "../features/webAppOnboarding/store/handleLogout";
import { colors } from "../styles/colors";
import { hexWithOpacity } from "../utils/hexWithOpacity";

export const Header = () => {
  return (
    <Container>
      <GenericSvg
        name="Logo"
        width={120}
        height={40}
        primaryColor={colors.dark}
        onClick={handleLogout}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  padding: 0 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid ${hexWithOpacity(colors.medium, 0.2)};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  background-color: ${colors.white};
`;
